import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoRstudioPro = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 500 500",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 250,
		cy: 250,
		r: 250,
		fill: "#75AADB"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M335.715 329.943h27.115v21.063h-41.398l-68.594-102.81h-36.556v81.747h35.75v21.063h-89.979v-21.063h30.908V148.776l-30.908-3.792v-19.933c11.701 2.663 21.869 4.519 34.62 4.519 19.206 0 38.815-4.519 58.022-4.519 37.282 0 71.901 16.947 71.901 58.345 0 32.037-19.206 52.373-48.983 61.008l58.102 85.539ZM216.282 227.861l19.61.403c47.854.726 66.253-17.673 66.253-42.205 0-28.648-20.739-39.946-47.047-39.946-12.427 0-25.258 1.13-38.816 2.663v79.085Z",
		fill: "#fff"
	})]
});
export default SvgLogoRstudioPro;
